export var TypeSelected = function TypeSelected(inputValue) {
    return {
        type: 'TYPESELECTED',
        payload: inputValue
    };
};
export var PurchasePriceUpdate = function PurchasePriceUpdate(inputValue) {
    return {
        type: 'PURCHASEPRICEUPDATE',
        payload: inputValue
    };
};
export var DownPaymentInUSDsUpdate = function DownPaymentInUSDsUpdate(inputValue) {
    return {
        type: 'DOWNPAYMENTINUSDSUPDATE',
        payload: inputValue
    };
};
export var DownPaymentInPercentsUpdate = function DownPaymentInPercentsUpdate(inputValue) {
    return {
        type: 'DOWNPAYMENTINPERCENTSSUPDATE',
        payload: inputValue
    };
};
export var CreditScoreUpdate = function CreditScoreUpdate(inputValue) {
    return {
        type: 'CREDITSCOREUPDATE',
        payload: inputValue
    };
};
export var ShowButtons = function ShowButtons(inputValue) {
    return {
        type: 'SHOWBUTTONSUPDATE',
        payload: inputValue
    };
};

export var propertyTypeUpdate = function propertyTypeUpdate(inputValue) {
    return {
        type: 'PROPERTYTYPEUPDATE',
        payload: inputValue
    };
};
export var propertyUsedUpdate = function propertyUsedUpdate(inputValue) {
    return {
        type: 'PROPERTYUSEDUPDATE',
        payload: inputValue
    };
};
export var lowRatesUpdate = function lowRatesUpdate(inputValue) {
    return {
        type: 'LOWRATESUPDATE',
        payload: inputValue
    };
};
export var lowRatesOptionUpdate = function lowRatesOptionUpdate(inputValue) {
    return {
        type: 'LOWRATESOPTION',
        payload: inputValue
    };
};
export var estimatedValueUpdate = function estimatedValueUpdate(inputValue) {
    return {
        type: 'ESTIMATEDVALUEUPDATED',
        payload: inputValue
    };
};
export var loanBalanceUpdate = function loanBalanceUpdate(inputValue) {
    return {
        type: 'LOANBALANCEUPDATED',
        payload: inputValue
    };
};
export var cashoutAmountUpdate = function cashoutAmountUpdate(inputValue) {
    return {
        type: 'CASHOUTAMOUNTUPDATED',
        payload: inputValue
    };
};
export var estimatedHomeValueUpdate = function estimatedHomeValueUpdate(inputValue) {
    return {
        type: 'ESTIMATEDHOMEVALUEUPDATED',
        payload: inputValue
    };
};
export var loanAmountTotalUpdate = function loanAmountTotalUpdate(inputValue) {
    return {
        type: 'LOANAMOUNTTOTALUPDATE',
        payload: inputValue
    };
};
export var zipCodeUpdate = function zipCodeUpdate(inputValue) {
    return {
        type: 'ZIPCODEUPDATE',
        payload: inputValue
    };
};
export var countryStateUpdate = function countryStateUpdate(inputValue) {
    return {
        type: 'COUNTRYSTATEUPDATE',
        payload: inputValue
    };
};
export var stateCountyUpdate = function stateCountyUpdate(inputValue) {
    return {
        type: 'STATECOUNTYUPDATE',
        payload: inputValue
    };
};
export var stateCountyNameUpdate = function stateCountyNameUpdate(inputValue) {
    return {
        type: 'STATECOUNTYNAMEUPDATE',
        payload: inputValue
    };
};
export var veteranUpdate = function veteranUpdate(inputValue) {
    return {
        type: 'VETERANUPDATE',
        payload: inputValue
    };
};
export var stateListUpdate = function stateListUpdate(inputValue) {
    return {
        type: 'STATELISTUPDATE',
        payload: inputValue
    };
};